const mediaItems = [
  {
    title: '暑期档热门大片合集',
    desc: '2026暑期档最受期待院线大片抢先看，动作科幻喜剧一网打尽',
    img: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20warm%20cinematic%20lighting%2C%20action%20film%20scene%20silhouettes%2C%20golden%20hour%20glow%2C%20movie%20poster%20aesthetic%2C%20dramatic%20composition%2C%20no%20text%2C%20rich%20amber%20and%20coral%20color%20tones%2C%20film%20grain%20texture&width=800&height=500&seq=media-card-01&orientation=landscape',
    tag: '热门推荐',
  },
  {
    title: '高分经典电影回顾',
    desc: 'IMDb与豆瓣双榜高分经典影片，每一部都值得反复品味',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20montage%20with%20vintage%20cinema%20aesthetic%2C%20golden%20film%20reels%2C%20soft%20warm%20lighting%2C%20nostalgic%20movie%20scenes%20collage%2C%20elegant%20dark%20background%20with%20amber%20accents%2C%20no%20text%2C%20artistic%20photography&width=800&height=500&seq=media-card-02&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '日韩热播剧集精选',
    desc: '最新日剧韩剧同步更新，热门连载追剧不等待',
    img: 'https://readdy.ai/api/search-image?query=Asian%20drama%20series%20visual%20collage%20with%20warm%20romantic%20lighting%2C%20Korean%20and%20Japanese%20drama%20aesthetic%2C%20soft%20pastel%20and%20coral%20tones%2C%20emotional%20scene%20composition%2C%20cinematic%20look%2C%20no%20text%2C%20artistic%20film%20photography&width=800&height=500&seq=media-card-03&orientation=landscape',
    tag: '追剧必备',
  },
  {
    title: '国产口碑好剧合集',
    desc: '近三年豆瓣8分以上国产剧精选，品质内容不容错过',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20quality%20TV%20drama%20visual%20with%20warm%20cinematic%20tone%2C%20historical%20and%20modern%20drama%20fusion%2C%20rich%20amber%20and%20gold%20color%20palette%2C%20elegant%20composition%2C%20no%20text%2C%20high%20end%20film%20photography%20style&width=800&height=500&seq=media-card-04&orientation=landscape',
    tag: '口碑佳片',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">
            精选内容
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门影视内容精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精心整理当前最受欢迎的影视内容专题，涵盖电影、电视剧、综艺等多类型资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <a key={i} href="#carousel" className="group block bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-accent-300/50 transition-all duration-300 no-underline">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}